import React from 'react'
import dayjs from 'dayjs'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileWorkExperience.scss'
import * as commonStyles from '../../../common/_common.scss'
import { modificationStates } from '../../../common/ReducerHelperFunctions/listDifferenceComputer'
import PropTypes from 'prop-types';

class AdviserProfileWorkExperience extends React.Component {

  static propTypes = {
    experiences: PropTypes.array.isRequired,
    editor: PropTypes.bool,
    comparison: PropTypes.bool,
    hideDeleted: PropTypes.bool,
    editingIndex: PropTypes.number,
    children: PropTypes.oneOfType([
      PropTypes.node, 
      PropTypes.arrayOf(PropTypes.node)
    ])
  }

  constructor (props) {
    super(props)
    this.renderWorkExperience = this.renderWorkExperience.bind(this)
  }

  createModificationClass (modificationState) {
    switch (modificationState) {
      case modificationStates.added:
        return commonStyles['item-added']
      case modificationStates.deleted:
        return commonStyles['item-deleted']
      case modificationStates.modified:
        return commonStyles['field-was-modified']
    }

    return ''
  }

  render () {
    const noExperiences = 'Not specified'
    // eslint-disable-next-line no-unused-vars
    const { experiences, editor, editingIndex, comparison, hideDeleted, children, ...props } = this.props

    return (
      <div className={styles['work-experience']} {...props}>
        <h4 className={styles['title']}><b> Work experience</b></h4>
        {(experiences || []).map(this.renderWorkExperience)}
        {(experiences || []).length <= 0 && <p>{noExperiences}</p>}
      </div>
    )
  }

  renderWorkExperience (job, index) {
    // While an admin is editing the pending profile, a deleted work experience should
    // disappear from the list (matching education). The read-only comparison view keeps it
    // struck-through so reviewers still see what was removed.
    if (this.props.hideDeleted && job.modificationState === modificationStates.deleted) {
      return null
    }
    if (this.props.editor && index === this.props.editingIndex) {
      return this.props.children
    }

    var modificationStyle = this.props.comparison ? this.createModificationClass(job.modificationState) : ''

    return (
      <div key={index}>
        <h4 className={styles['work-experience-job-position'] + ' ' + modificationStyle}>{job.position} {this.props.children && (!this.props.editor || this.props.comparison) ? this.props.children[index] : ''}</h4>
        <h5 className={styles['work-experience-company'] + ' ' + modificationStyle}>{job.company}</h5>
        <p className={styles['work-experience-period-of-employment'] + ' ' + modificationStyle}>
          { dayjs(job.positionStartDate).format('MMM YYYY')}
          <span>&nbsp;-&nbsp;</span>
          {job.positionEndDate !== null && dayjs(job.positionEndDate).format('MMM YYYY')}
          {job.positionEndDate === null && 'Present'}
        </p>
      </div>
    )
  }

}

export default (AdviserProfileWorkExperience)
